'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "Details": "Polaris-TopBar-UserMenu__Details"
};

exports.default = styles;
